import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";

import Eko_Home from './eko/home.js';
import Eko_Day from './eko/day.js';
import Eko_HH from './eko/hh.js';
import Eko_Vgrp from './eko/vgrp.js';
import Eko_Period from './eko/period.js';
import Eko_Trs from './eko/trs.js';
import Eko_Tcr from './eko/tcr.js';
import Eko_Arts from './eko/arts.js';
import Eko_Bets from './eko/bets.js';

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";

function web01() {

    var html =
    <div className="">
        Test
    </div>
    ;
    return html;
}

class Pos_Eko extends React.Component {
    //var sdo = useContext(SDOContext); // Functional
    //static contextType = SDOContext; // Class

    constructor(props, context) {
        super(props);

        this.s1ref = React.createRef();
        this.s2ref = React.createRef();

        this.webStore = props.store;
        this.state = { pgid: 11, stat: [] };
        this.state.open = false;
        this.state.pdfopen = false;
        this.state.xxopen = false;
        this.state.pdf_uri = "";
        this.state.seldate = new Date('2020-03-24T13:11:54');
        this.state.row = null;
        this.state.info = "";
        this.state.top = 0;
        this.state.sdo = {};
        //this.state.sdo = context;
        //context.posrend = this;
        this.state.step = 1;
        this.state.pdf = 0;
        this.state.pdf_uri = "";
        this.state.mnus = ["m00", "m01", "m02", "m03", "m08", "m09"];
        this.state.mnu_sel = "m00";
    }
    componentDidMount(){
        //var sdo = sessionStorage.getItem("svp");
        //if(sdo) this.setState({sdo: JSON.parse(sdo) });
        //this.cdi_step();
    }

    componentWillUnmount(){
            this.setState({info: "UUU" });
    }
   header_css() {
  	    var css = {};
		if(this.state.top) {
			css.color = "#fff";
			css.background = "transparent";
			css.height = "50px";
			//css["background"] = "green";
		}
		else {
			css.color = "#000";
			css.background = "#fff";
		    css.height = "50px";
        }

		return css;
    }
   ham_mnu_css() {
  	    var css = {};
		if(this.state.top) {
			css.display = "flex";
			css.display = "none";
		}
		else {
			css.display = "none";
        }

		return css;
    }
    header_class() {
  	    var cls = "web-top";
		if(this.state.top) {
			//cls = cls + " web-head_1";
		}
		//else cls = cls +  " web-header";

		return cls;
    }

    sdo_upd() {
        var sdo = this.state.sdo;
        if(!sdo.fid) sdo.fid = "0";
        sdo.fid = ((sdo.fid * 1) + 1).toString();
        this.setState({sdo: sdo})
        sessionStorage.setItem("svp", JSON.stringify(this.state.sdo));
        //this.props.history.push("cas");
    }
    sdo_ctx() {
        sessionStorage.removeItem('svp');
        //sessionStorage.clear();
    }
    sdo_cas() {
        this.context.fid = "45";
        this.props.history.push("cas");
    }
    ct_show(id) {
        //alert(id);
        const element = document.getElementById(id);
        if (element) element.scrollIntoView();
        //const tesNode = ReactDOM.findDOMNode(id);
        //window.scrollTo(0, tesNode.offsetTop);
    }
    w00_css() {
  	    var css = {};
        //css.height = window.innerHeight;
        //css['minHeight'] = window.innerHeight;
		return css;
    }
    mnu_sel(mnuid) {

        this.setState({mnu_sel: mnuid});
        const element = document.getElementById(mnuid);
        if (element) element.scrollIntoView();
    }

   mnu_item_css(mnuid) {
  	    var css = {};

        if(this.state.mnu_sel == mnuid) {
			///css.background = "#080";
			//css.color = "#fff";
			css.color = "#080";
        }
		return css;
    }
    row_css(row) {
  	    var css = {};
		if(this.state.row) {
		if(this.state.row.ank == row.ank) {
			css.background = "#080";
			css.color = "#fff";
		}
		}
		return css;
    }
    login() {
        this.setState({login: true });
        //this.props.history.push("pos");
    }
    row_icon_css() {
  	    var css = {};
        css.paddingTop = "5px";
        css.fontSize = "20px";
		return css;
    }

    fknGo(url) {
        this.props.history.push(url);
   };
    logout() {
        this.props.history.push("/");
   };
  mnu_style(id, op) {
      var css = {};
      if(id == op) {
          css.background = "#080";
          css.color = "#fff";
      }
      return css;
  }

    render() {
      var mnus = ["pt", "oms", "th", "menu"];
      var path = window.location.pathname;
      var op = path.split("/").pop();
      if( !mnus.includes(op) ) op = "home";

        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
        const handleDateChange = date => {
            this.setState({seldate: date });
        };

        return (
            <div className="web-app">

            <div className="flex-col flex">

                <Routes>
                    <Route path="day/*" forceRefresh={true} element={ <Eko_Day store={this.webStore} />} />
                    <Route path="hh/*" forceRefresh={true} element={ <Eko_HH store={this.webStore} />} />
                    <Route path="vgrp/*" forceRefresh={true} element={ <Eko_Vgrp store={this.webStore} />} />
                    <Route path="period/*" forceRefresh={true} element={ <Eko_Period store={this.webStore} />} />
                    <Route path="trs/*" forceRefresh={true} element={ <Eko_Trs store={this.webStore} />} />
                    <Route path="tcr/*" forceRefresh={true} element={ <Eko_Tcr store={this.webStore} />} />
                    <Route path="arts/*" forceRefresh={true} element={ <Eko_Arts store={this.webStore} />} />
                    <Route path="bets/*" forceRefresh={true} element={ <Eko_Bets store={this.webStore} />} />
                    <Route path="*" forceRefresh={true} element={ <Eko_Home store={this.webStore} />} />
                </Routes>

            </div>

         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default Pos_Eko;
